import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Modal, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 3, 2),
    borderRadius: 10,
    outline: 'none'
  }
}));

const DeleteConfirmationModal = ({
  open,
  handleClose,
  message,
  handleDelete
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={classes.modal}
    >
      <div className={classes.paper}>
        <Typography
          variant="h5"
          gutterBottom
          style={{
            fontWeight: 'bold',
            fontFamily: 'Arial',
            marginBottom: 16
          }}
        >
          Confirmação
        </Typography>

        <Typography variant="body1">
          {message}
        </Typography>

        <div
          style={{
            marginTop: 16,
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
            style={{ marginRight: 8 }}
          >
            Não
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={handleDelete}
          >
            Sim
          </Button>
        </div>
      </div>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  itemId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  message: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default DeleteConfirmationModal;